import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

const parseJsonBlob = async (response) => {
    const contentType = response?.headers?.['content-type'] || ''
    if (response?.data instanceof Blob && contentType.includes('json')) {
        try {
            response.data = JSON.parse(await response.data.text())
        } catch (error) {
            return response
        }
    }
    return response
}

export const paymentTransactionInvoice = createAsyncThunk('paymentTransactionInvoice', async ({ id }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `payment_transaction/${id}/invoice`,
            responseType: 'blob',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return parseJsonBlob(res)
    } catch (error) {
        return parseJsonBlob(error.response)
    }
})

const paymentTransactionInvoiceSlice = createSlice({
    name: 'paymentTransactionInvoice',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(paymentTransactionInvoice.fulfilled, (state, action) => {
            if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else if (action?.payload?.status === 200) {
                state.data = { id: action.meta.arg.id }
            } else {
                state.data = null
            }
        });
        builder.addCase(paymentTransactionInvoice.rejected, () => { })
    }
})

export default paymentTransactionInvoiceSlice.reducer;
